<template>
  <div class="bodybox">
    <div class="columnBox">
      <div class="columnBoxInnner">
        <div class="columnBoxInnnerList">
          <div v-for="(item,index) in columnlist" :key="index" :class="currrentcolumn==index?'activename':'column_a'" @click="changeNowColumn(item.value,index)">
            <span class="nameshow">{{ item.name }}</span><span v-show="index<columnlist.length-1" class="a_span">/</span>
          </div>
        </div>
      </div>
      <Centerlistnews :columnlist="currentData" :isvdo="true" />
      <div v-if="loadAll" class="atfoot loadMore">
        已经到底部了
      </div>
      <div v-else class="loadMore" @click="addMore">
        加载更多>>
      </div>
    </div>
  </div>
</template>
<script>

import Centerlistnews from '@/components/centerlist_albumn'
import { addalbumData } from '@/api/api.js'

export default {
  components: { Centerlistnews },
  props: ['columnlist', 'alldata'],
  data() {
    return {
      currentPage: 1,
      albumTypeIds: '',
      currrentcolumn: 0,
      loadAll: false,
      page: 1,
      currentData: this.alldata.albumPage.listMapData
    }
  },
  computed: {

  },
  created() {

  },
  mounted() {
    this.page = this.alldata.albumPage.page
    if (this.page === this.currentPage * 1) {
      this.loadAll = true
    }
  },
  methods: {
    changeNowColumn: function(ID, index) {
      var obj = {}
      obj.index = '1'
      obj.size = '8'
      if (ID) {
        obj.albumTypeIds = ID
      }
      this.albumTypeIds = ID
      this.currentPage = 1
      this.currrentcolumn = index
      this.loadAll = false
      addalbumData(obj).then(res => {
        this.currentData = []
        this.currentData = res.data.listMapData
        this.page = res.data.page
      })
      if (this.currentPage >= this.page) {
        this.loadAll = true
      }
    },
    // /加载更多
    addMore: function() {
      var obj = {}
      if (this.albumTypeIds) {
        obj.albumTypeIds = this.albumTypeIds
      }
      obj.index = this.currentPage + 1
      obj.size = '12'
      addalbumData(obj).then(res => {
        this.currentData = this.currentData.concat(res.data.albumPage.listMapData)
        this.currentPage += 1
        if (this.currentPage >= this.page) {
          this.loadAll = true
        }
      })
    }
  }

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    /*.bodybox{*/
        /*background-color: #FAFAFA;*/
    /*}*/
    .columnBoxInnner{
      height: 60px;
      line-height: 60px;
      text-align: center;
      background-color: #fff;
    }
    .columnBox{
        /*margin: 20px auto;*/
        text-align: center;
        background-color: #FAFAFA;
        .activename{
            display: inline-block;
            cursor: pointer;
            .a_span{
                margin: 0 16px;
            }
            .nameshow{
                color: #ed4040;
                font-size: 16px;
              font-weight: 600;
            }

        }
        .column_a{
            display: inline-block;
            cursor: pointer;
            font-size: 16px;
            .a_span{
                margin: 0 16px;
            }
            .nameshow{
                font-size: 16px;
                color: #333333;
               font-weight: 600;
                &:hover{
                    color: #ed4040;
                }
            }
        }
      .loadMore{
        height: 45px;
        line-height: 45px;
        font-size: 14px;
        color: #999999;
        background-color: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 3px;
        cursor: pointer;
        display:inline-block;
        width: 100%;
        transition: 0.5s;
        margin-bottom: 50px;
        &:hover{
          color: #ed4040;
          border: 1px solid #ed4040;
        }
      }
        .atfoot{
            cursor: auto;
        }
    }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {

    .columnBoxInnner{
      width: 100%;
      overflow: hidden;
      overflow-x: auto;
      margin-top: 20px;
      margin-bottom: 10px;
      .columnBoxInnnerList{
        white-space: nowrap;
        padding: 0 20px;
      }
    }
  }
</style>
